import axios from "axios";

export const axiosInstance = axios.create({
    baseURL: "https://melophonica-blog.herokuapp.com/api/"
})